import { getStorage } from '@minerva-analytics/pantheon';
import request from '../../../request/actions';

export const UPDATE_CAMPAIGN_START = `UPDATE_CAMPAIGN_START`;
export const UPDATE_CAMPAIGN_SUCCESS = `UPDATE_CAMPAIGN_SUCCESS`;
export const UPDATE_CAMPAIGN_FAILURE = `UPDATE_CAMPAIGN_FAILURE`;

const updateCampaignStart = () => ({
  type: UPDATE_CAMPAIGN_START,
});

const updateCampaignSuccess = () => ({
  type: UPDATE_CAMPAIGN_SUCCESS,
});

const updateCampaignFailure = (error) => ({
  type: UPDATE_CAMPAIGN_FAILURE,
  error,
});


export const updateCampaign = (id) => async (dispatch) => {
  dispatch(updateCampaignStart());
  // Store pk_medium and pk_source on user model
  const source = getStorage({ key: `pk_source`, forceCookies: true });
  const medium = getStorage({ key: `pk_medium`, forceCookies: true });
  const updateData = {
    campaign_source: source || `direct`,
    campaign_medium: medium || `direct`,
  };
  try {
    await dispatch(request(`/users/${id}/`, `PATCH`, updateData));
    dispatch(updateCampaignSuccess());
  } catch (e) {
    dispatch(updateCampaignFailure(e));
  }
};
